// import { UsersRolesManagementComponent } from "./userRolesManagement";
// import { UsersManagementComponent } from "./usersManagement/usersManagement";
import { UsersManagementComponent } from "./usersManagement/usersManagement-ang7";
import { RolesManagementComponent } from './roles-management/roles-management.component';
import { ProjectManagementComponent } from './project-management/project-management.component';
import { UsersComponent } from './usersManagement/users/users.component';
import { UsersGroupsComponent } from "./usersManagement/users-groups/users-groups.component";
import { DomainManagerComponent } from "./advancedManagement/domain-manager/domain-manager.component";
import { OidcComponent } from "./advancedManagement/oidc-configuration/oidc.component";
import { ProjectGroupsComponent } from "./advancedManagement/project-groups/project-groups.component";
// import { AdvancedManagementComponent } from "./advancedManagement/advancedManagement";
import { UserComponent } from "./usersManagement/users/user/user.component";
import { UserDomainComponent } from "./usersManagement/users/user-domain/user-domain.component";
import { UserCmsComponent } from "./usersManagement/users/user-cms/user-cms.component";
import dbmSharedComponent from '../../common/components/dbm-components';
import { downgradeComponent } from '@angular/upgrade/static';
import { AdvancedManagementComponent } from './advancedManagement/advancedManagement-ang7'
import { UsersRolesManagementComponent } from "./userRolesManagement-ang7";
import { userActions } from "../../../store/reducers/userReducer";
import { UserVaultComponent } from "@app/authorized/usersRolesManagement/usersManagement/users/user-vault/user-vault.component";

export default angular.module('usersRoles', [dbmSharedComponent.name])
    // .component('usersRolesManagement', UsersRolesManagementComponent)
    .directive('usersRolesManagement', downgradeComponent({ component: UsersRolesManagementComponent }))
    .directive('usersManagement', downgradeComponent({ component: UsersManagementComponent }))
    .directive('rolesManagement', downgradeComponent({ component: RolesManagementComponent }))
    .directive('projectManagement', downgradeComponent({ component: ProjectManagementComponent }))
    .directive('oidcConf', downgradeComponent({ component: OidcComponent }))
    .directive('users', downgradeComponent({ component: UsersComponent }))
    .directive('user', downgradeComponent({ component: UserComponent }))
    .directive('userDomain', downgradeComponent({ component: UserDomainComponent }))
    .directive('userVault', downgradeComponent({ component: UserVaultComponent }))
    .directive('userCms', downgradeComponent({ component: UserCmsComponent }))
    .directive('usersGroups', downgradeComponent({ component: UsersGroupsComponent }))
    .directive('domainManager', downgradeComponent({ component: DomainManagerComponent }))
    .directive('projectGroups', downgradeComponent({ component: ProjectGroupsComponent }))
    .directive('advancedManagement', downgradeComponent({ component: AdvancedManagementComponent }))

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state({
                name: 'app.authorized.usersRolesManagement',
                absolute: true,
                url: '/usersRolesManagement',
                template: `<users-roles-management></users-roles-management>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.usersManagement',
                url: '/usersManagement',
                template: `<users-management></users-management>`,
                params: {
                    listMenu: [
                        { route: 'app.authorized.usersRolesManagement.usersManagement.users', name: 'Users' },
                        { route: 'app.authorized.usersRolesManagement.usersManagement.usersGroups', name: 'User Groups' }
                    ]
                },
                resolve: {
                    isGlobalAdmin: ["store", "$state", (store, $state) => {
                        return store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
                            store.dispatch({ type: userActions.GET_PERMISSIONS_FOR_USER, payload: { userId: res.data.id } }).then((res) => {
                                const isValid = res.find(item => (item.key == "Admin" && item.value == true) || (item.key == "AddUser" && item.value == true) || (item.key == "AddUserGroup" && item.value == true)) //global admin group
                                if (!isValid) {
                                    $state.go("app.authorized.projects");
                                }
                            });
                        });
                    }]
                }
            })
            .state({
                name: 'app.authorized.usersRolesManagement.rolesManagement',
                url: '/rolesManagement',
                template: `<roles-management></roles-management>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.projectManagement',
                url: '/projectManagement',
                template: `<project-management></project-management>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.advancedManagement',
                url: '/advancedManagement',
                template: `<advanced-management></advanced-management>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.usersManagement.users',
                url: '/users',
                template: `<users></users>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.usersManagement.usersGroups',
                url: '/usersGroups',
                template: `<users-groups></users-groups>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.advancedManagement.oidcConfiguration',
                url: '/oidcConfiguration',
                template: `<oidc-conf></oidc-conf>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.advancedManagement.domainManager',
                url: '/domainManager',
                template: `<domain-manager></domain-manager>`
            })
            .state({
                name: 'app.authorized.usersRolesManagement.advancedManagement.projectGroups',
                url: '/projectGroups',
                template: `<project-groups></project-groups>`
            })
    }]);



// WEBPACK FOOTER //
// ./src/app/authorized/usersRolesManagement/index.js